export default __webpack_public_path__ + "static/media/logo-text-white.6ccc5b94.png";